import { CircularProgress } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import downloadIcon from '../../assets/icons/icon_download-image.svg';
import {
  DownloadButtonProps,
  DownloadCaseButton,
} from '../../common/components/DownloadCaseButton';

import { ImageListTableButton } from './ImageListTableButtons';

interface DownloadMultipleCaseButtonProps {
  caseIds: string[];
}
export const DownloadMultipleCaseButton = ({
  caseIds,
}: DownloadMultipleCaseButtonProps) => {
  return (
    <DownloadCaseButton
      caseIds={caseIds}
      DownloadButton={DownloadMultipleCaseButtonContent}
    />
  );
};

const DownloadMultipleCaseButtonContent = ({
  isDownloading,
  onClick,
}: DownloadButtonProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.imageList.downloadButton',
  });

  return (
    <ImageListTableButton
      icon={downloadIcon}
      text={
        isDownloading ? (
          <CircularProgress size={20} style={{ color: '#a4a6ac' }} />
        ) : (
          `${t('label')}`
        )
      }
      onClick={isDownloading ? undefined : onClick}
    />
  );
};
